import React from "react";
import { FormProvider, useForm } from "react-hook-form";

type FiltersBackgroundProps = {
  children: React.ReactNode;
  className?: string;
};
export const FiltersBackground = ({ children, className = "" }: FiltersBackgroundProps) => {
  return (
    <div className={`flex flex-col rounded-lg bg-slate-200 px-4 pb-4 pt-2 dark:bg-slate-800 ${className}`}>
      {children}
    </div>
  );
};

type FormFiltersBackgroundProps = {
  defaultValues?: any;
  header?: string;
} & FiltersBackgroundProps;
export const FormFiltersBackground = ({
  children,
  className,
  defaultValues,
  header = "Filtry",
}: FormFiltersBackgroundProps) => {
  const methods = useForm({ defaultValues: defaultValues });
  return (
    <div className={`my-4 flex flex-col rounded-lg bg-slate-200 px-4 pb-4 pt-2 dark:bg-slate-800 ${className}`}>
      {header && (
        <div className="text-primary-800 -ml-1 -mt-1 text-xs font-semibold uppercase tracking-widest">{header}</div>
      )}
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(() => {})}>{children}</form>
      </FormProvider>
    </div>
  );
};
